import { Icon } from "@/components/Atoms/Icon"

export const Chip = ({ label, onClose }: { label: string; onClose: () => void }) => {
  return (
    <span className="inline-flex items-center gap-1 rounded-full border border-orange-500 bg-orange-500/20 px-2 py-1 text-xs text-orange-500">
      <button
        onClick={onClose}
        className=""
      >
        <Icon
          state="outline"
          name="circle-xmark"
          size={15}
        />
      </button>
      <span>{label}</span>
    </span>
  )
}
